import type { RevenueVsExpensesInsightsDTO } from "../models/revenueVsExpensesInsightsDto";
import type { RevenueVsExpensesInsightsEntity } from "../../domain/entities/RevenueVsExpensesInsightsEntity";

function mapSentiment(s: string): "positive" | "neutral" | "negative" {
  const t = (s ?? "").toLowerCase();
  if (t === "good") return "positive";
  if (t === "bad") return "negative";
  return "neutral";
}

export function revenueVsExpensesInsightsDtoToEntity(
  dto: RevenueVsExpensesInsightsDTO,
): RevenueVsExpensesInsightsEntity {
  const monthCountRaw = dto.month_count;
  const monthCount =
    typeof monthCountRaw === "number" && Number.isFinite(monthCountRaw)
      ? monthCountRaw
      : undefined;

  return {
    title: dto.title ?? "",
    body: dto.body ?? "",
    sentiment: mapSentiment(dto.sentiment ?? "neutral"),
    rangeLabel: dto.range_label?.trim() || undefined,
    monthCount,
  };
}
